import { useQuery } from '@tanstack/react-query';
import { useTenant } from '@/modules/tenant/presentation/hooks/use-tenant';
import { examContainer } from '../../di/container';

/**
 * As questões do ensaio, com gabarito, buscadas pelos ids do mapper da
 * edição. **A mesma consulta serve às duas telas** — o ensaio (que só mostra
 * enunciado e alternativas, via `toSimuladoQuestions`) e o diagnóstico (que
 * precisa da correção) —, e o cache faz o diagnóstico abrir sem ir à rede.
 *
 * `staleTime: Infinity` porque as questões não mudam durante a visita, e uma
 * revalidação no meio do ensaio poderia trocá-las debaixo das respostas.
 */
export function useExam() {
  const { id, edition } = useTenant();

  return useQuery({
    queryKey: ['ensaio', id, edition.year, edition.ensaioQuestionIds],
    queryFn: () =>
      examContainer.repository.getSimulado(edition.ensaioQuestionIds),
    staleTime: Infinity,
  });
}
